import React from 'react';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Pagination from "react-js-pagination";
import 'react-confirm-alert/src/react-confirm-alert.css';
import { ToastContainer, toast } from 'react-toastify';
import * as constant from '../../constants/constant';
import 'react-toastify/dist/ReactToastify.css';
// import { this.props.history } from 'react-router';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import * as specialistActions from '../../actions/specialistActions';

class MyAssistant extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			userListData: [],
			flag: 1,
			activePage: 1,
			count: 10,
			sortColumnName: '',
			sortOrder: -1,
			status: true,
      usertype :'',
      specialistAssistant:{}
		};
		this.goToAddUserPage = this.goToAddUserPage.bind(this)
		this.goToEditUserPage = this.goToEditUserPage.bind(this)
		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);
	

	}

	componentWillMount() {
		if (localStorage.getItem('urlLocation') != undefined) {
			localStorage.removeItem('urlLocation')
    }
  var  specialistId = localStorage.getItem('userId')
		let object = {
			// page: this.state.activePage,
			// count: this.state.count,
			specialistId: specialistId
		}
		this.props.actions.getSpecialistsAssistant(object);
	}

	componentWillReceiveProps(nextProps) {

		
    if( nextProps.specialistListAssistant &&  nextProps.specialistListAssistant.assistants){
			this.setState({
				userListData : nextProps.specialistListAssistant.assistants
			})

    }


	}
	// function for set sort icon on table header
	_sortClass(filterName) {
		return "fa fa-fw " + ((filterName == this.state.sortColumnName) ? ("fa-sort-" + this.state.sortOrder) : "fa-sort");
	}


	//function for sorting
	sortChanged(sortColumnName, order, e) {
		e.preventDefault();

		this.state.sortColumnName = sortColumnName;
		this.state.page = 1;
		this.state.sortOrder = order == 1 ? -1 : 1;

		let userToken = localStorage.getItem('token');
		// let patientId = localStorage.getItem('userId');
		const sorting = {}
		sorting[sortColumnName] = order.toString().toLowerCase() == 1 ? -1 : 1
		this.state.sorting = sorting;
		let appointmentObj = {
			token: userToken,
			page: this.state.activePage,
			count: this.state.count,
			sorting: sorting
		};

		this.props.actions.getAllSpecialists(appointmentObj);
	}

	goToAddUserPage() {

		localStorage.setItem('urlLocation', '/user/userList')
		this.props.history.push('/specialist/add-user');
	};
	goToEditUserPage(index) {
		localStorage.setItem('urlLocation', '/user/userList')
		this.props.history.push('/specialist/edit-user/' + this.state.userListData[index]._id);
	}

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	render() {
		var userListData = this.state.userListData
		
		var rows = [];
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		var defaultImagePath =user.gender=='Male'? constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_m.png': constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER +constant.COMMON_FOLDER +'doctor_f.png';



		if (user.image == constant.DEFAULT_USER_IMAGE) {
			if (user.gender == 'Male') {
				imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_m.png'
			}
			else{
			  imagePath =  constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER  + constant.COMMON_FOLDER + 'doctor_f.png'
			}
		} else {
			var imagePath = constant.PRODUCTION_IMAGE_URL + constant.UPLOAD_FOLDER + localStorage.getItem('userId') + '/' + user.image;
		}
		var userType = localStorage.getItem('userType');
		return (
            <div>
                	<header className="main-header">
					<Link to={condition ? "/specialist/my-appointment" : null} className="logo">						<span className="logo-mini">{userType === 'specialist' ? <img src={require('../../images/img/logo_er_ms_specialist.png')} alt="" /> : <img src={require('../../images/img/logo_er_ms.png')} alt="" />}</span>
						<span className="logo-lg">{userType === 'specialist' ? <img src={require('../../images/img/logo_er.png')} alt="" /> : <img src={require('../../images/img/logo_er_old.png')} alt="" />}</span> </Link>
					<nav className="navbar navbar-static-top" role="navigation">
						<Link href="#" className="sidebar-toggle" data-toggle="push-menu" role="button" onClick={this.toggle}> <img src={require('../../images/img/menu_list.svg')} alt="" /> <span className="sr-only">Toggle navigation</span> </Link>
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

									<Link href="#" className="dropdown-toggle" data-toggle="dropdown">
										<img src={imagePath} className="user-image" alt="User Image" onError={(e) => { e.target.src = defaultImagePath }} />
										<span className="hidden-xs name-capitalize">{user.firstName ? user.firstName : ''} {user.lastName ? user.lastName : ''}</span> </Link>
									<ul className={this.state.logoutButton === true ? "dropdown-menu popupdropdown show" : "dropdown-menu popupdropdown"}>

										<li className="user-setting">	<Link to={{ pathname: "/specialist/my-settings", state: 1 }}>

											<img
												src={require('../../images/Slicing/Settings-profile.png')}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span>Settings</span>
										</Link></li>
										<li
											className="user-footer passwordLink"
										// style={{ textAlign: "center" }}
										>

											<Link

												className="uploadLink"
												onClick={this._logout}
											>
												<img
													src={require('../../images/Slicing/logout-profile.png')}
													className="user-image"
													alt="User Image"
													onError={e => {
														e.target.src = defaultImagePath;
													}}
												/>
												<span>	Sign out</span>
											</Link>
										</li>
									</ul>
								</li>
							</ul>
						</div>
					</nav>
				</header>
			<div className="content-wrapper">
				<section className="content container-fluid">
					<ToastContainer />
					<div className="row">
						<div className="col-md-12">
							<div className="boxMrgB proCalendar">
								<div className="nav-tabs-custom">
									<ul className="nav nav-tabs">
										<li>
											<Link
												to="#tab_1"
												data-toggle="tab"
												className="active show"
											>
												Assistant User
											</Link>
										</li>

									</ul>
									<div className="uploadImg-btn">

										<button className="btn btn-warning btn-lg" onClick={this.goToAddUserPage}>	<span> <img src={require('../../images/img/add.png')} /> </span> Add User</button>
									</div>
									<div className="row">
										<div className="col-md-12">
											<div className="tab-content tabother ">
												<div className="row">
													<div className="box-body table-responsive no-padding aTable">
													<div className="table-responsive">
														<table className="table">
															<tbody>
																<tr>
																	<th onClick={this.sortChanged.bind(this, 'userName', this.state.sortOrder)}>
																		Name
                                									<i className={this._sortClass('appointmentspecialistname')}></i></th>
																	<th onClick={this.sortChanged.bind(this, 'email', this.state.sortOrder)}>Email<i className={this._sortClass('appointmentspecialistname')}></i></th>
																	<th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Created Date<i className={this._sortClass('appointmentspecialistname')}></i></th>
																	{/* <th onClick={this.sortChanged.bind(this, 'createdAt', this.state.sortOrder)}>Last loggedin<i className={this._sortClass('appointmentspecialistname')}></i></th> */}
																	<th >Action</th>
																</tr>
                             { this.state.specialistAssistant ?<tr>
                              <td>{this.state.specialistAssistant.userName }</td>
                              <td>{this.state.specialistAssistant.email }</td>
                              <td>{this.state.specialistAssistant.createdAt }</td>
                              </tr>
                            :<tr><td colSpan={4} className="text-center">No user there</td></tr>
                            }
															</tbody>
														</table>
													</div></div>
												</div>
												{(userListData && userListData.length > 0) ?
													<div className="row">
													<div className="col-sm-5"><div className="showingEntries">Showing {(this.state.activePage * this.state.count) - (this.state.count - 1)} to {(this.state.activePage * this.state.count) > this.state.totalCount ? this.state.totalCount : (this.state.activePage * this.state.count)} of {this.state.totalCount} entries</div></div>
														<div className="col-sm-7 text-right" style={{ "cursor": "pointer" }}>
															<Pagination
																prevPageText='Prev'
																nextPageText='Next'
																hideFirstLastPages
																activePage={this.state.activePage}
																itemsCountPerPage={10}
																totalItemsCount={this.state.totalCount}
																pageRangeDisplayed={10}
																onChange={this.handlePageChange}
															/>

														</div>

													</div> : ''}
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
				<div className="Copyrightafterlogin">
				<p>Medfix &copy; 2018. All rights reserved</p>

				</div>
			</div>
            </div>
		);
	}
}

//this tells what state should expose on props
function mapStateToProps(state, ownProps) {
	
	return {
		// userListData: state.adminUser.userListData ? state.adminUser.userListData.data : [],
		// totalCount: state.adminUser.userListData ? state.adminUser.userListData.totalCount : 0,
    // success: state.adminUser.userListData ? state.adminUser.userListData.success : false,
    specialistListAssistant: state.specialist.specialistListAssistant
};
}
// this tells what action should expose on props
// bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(specialistActions, dispatch)
	};
}
export default connect(mapStateToProps,
     mapDispatchToProps
)(MyAssistant);
